export const ErrorCodes = {
  FORBIDDEN_REQUEST: 'MER-PAY-1000',
  REFERENCE_SPECIAL_CHARACTERS: 'MER-PAY-2009',
  CRYPTO_ADDRESS_INVALID_FOR_WHITELISTING: 'MER-XP-2001',
  CRYPTO_ADDRESS_ALREADY_WHITELISTED: 'MER-XP-2002',
  INVALID_ADDRESS: 'MER-PAY-2027',
  FAILED_FINCRIME_INVALID_ADDRESS: 'MER-PAY-2028',
  BENEFICIARY_MANAGEMENT_ERROR: 'BEN-MAN-001',
  REPORT_PROCESSING: 'reportRequestCurrentlyProcessing',
  REPORT_LEDGER_WALLET_NOT_FOUND: 'bvnk:ledger:2103',
  REPORT_LEDGER_DUPLICATE_REQUEST: 'bvnk:ledger:2104',
  REPORT_LEDGER_PDF_TRANSACTIONS_LIMIT_REACHED: 'bvnk:ledger:2110',
  NOT_VERIFIED: 'MER-PAY-2050',
  CURRENCY_NOT_SUPPORTED: 'MER-XP-2007',
  UNKNOWN_EXCEPTION: 'MER-PAY-3000',
  UNSUPPORTED_TIME_PERIOD: 'bvnk:ledger:2109',
  CONTACT_ALREADY_EXISTS: 'bvnk:beneficiary:4009',
}
